(function () {
  const TRANSITION_DURATION = "400ms";
  const TRANSITION_TYPE = "ease-in-out";
  const ANSWER_SELECTOR = ".collapsible-content-item__answer";
  const ITEM_SELECTOR = ".collapsible-content-item";
  const FOCUSABLE =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const slideUp = (element) => {
    if (!element) return;
    const height = element.getBoundingClientRect().height;

    element.style.height = `${height}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${TRANSITION_DURATION} ${TRANSITION_TYPE}, opacity ${TRANSITION_DURATION} ${TRANSITION_TYPE}`;

    void element.offsetHeight;

    element.style.height = "0";
    element.style.opacity = "0";

    const cleanup = () => {
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      element.removeEventListener("transitionend", cleanup);
    };

    element.addEventListener("transitionend", cleanup);
  };

  const slideDown = (element) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${TRANSITION_DURATION} ${TRANSITION_TYPE}, opacity ${TRANSITION_DURATION} ${TRANSITION_TYPE}`;

    void element.offsetHeight;

    element.style.height = `${height}px`;
    element.style.opacity = "1";
  };

  class CollapsibleContent {
    constructor(el) {
      this.el = el;
      this.items = Array.from(el.querySelectorAll(ITEM_SELECTOR));
      this.eventController = new AbortController();

      this.items.forEach((item) => {
        if (item.getAttribute("data-default-opened") === "true") {
          const answer = item.querySelector(ANSWER_SELECTOR);
          if (answer) answer.style.height = `${answer.scrollHeight}px`;
        }

        this._setAnswerFocusability(item, item.classList.contains("active"));

        item.addEventListener("click", (event) => this._toggle(item, event), {
          signal: this.eventController.signal,
        });

        item.addEventListener(
          "keydown",
          (event) => this._handleKeydown(item, event),
          { signal: this.eventController.signal }
        );
      });
    }

    destroy() {
      this.eventController.abort();
    }

    _setAnswerFocusability(item, isOpen) {
      const answer = item.querySelector(ANSWER_SELECTOR);
      if (!answer) return;

      answer.querySelectorAll(FOCUSABLE).forEach((el) => {
        if (isOpen) {
          el.removeAttribute("tabindex");
        } else {
          el.setAttribute("tabindex", "-1");
        }
      });
    }

    _close(item) {
      item.classList.remove("active");
      item.removeAttribute("data-default-opened");
      item.setAttribute("aria-expanded", "false");
      slideUp(item.querySelector(ANSWER_SELECTOR));
      this._setAnswerFocusability(item, false);
    }

    _closeOthers(currentItem) {
      this.items.forEach((item) => {
        if (item !== currentItem) this._close(item);
      });
    }

    _toggle(item, event) {
      const answer = item.querySelector(ANSWER_SELECTOR);
      if (!answer) return;

      if (event?.target?.closest("a")) return;

      if (item.classList.contains("active")) {
        this._close(item);
        return;
      }

      this._closeOthers(item);
      item.classList.add("active");
      item.setAttribute("aria-expanded", "true");
      slideDown(answer);
      this._setAnswerFocusability(item, true);
    }

    _handleKeydown(item, event) {
      if (event.key !== "Enter" && event.key !== " ") return;

      const answer = item.querySelector(ANSWER_SELECTOR);
      if (answer && answer.contains(document.activeElement)) return;

      event.preventDefault();
      this._toggle(item);
    }
  }

  function initRoot(root) {
    if (!root) return;

    if (root._collapsibleContentInstance) {
      root._collapsibleContentInstance.destroy();
      root._collapsibleContentInstance = null;
    }

    root._collapsibleContentInstance = new CollapsibleContent(root);
  }

  function initSection(element) {
    if (!element) return;

    if (element.classList?.contains("collapsible-content")) {
      initRoot(element);
    }

    element
      .querySelectorAll?.(".collapsible-content")
      .forEach((root) => initRoot(root));
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeCollapsibleContentEvents) {
    window.__themeCollapsibleContentEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      event.target.querySelectorAll(".collapsible-content").forEach((el) => {
        if (!el._collapsibleContentInstance) return;

        el._collapsibleContentInstance.destroy();
        el._collapsibleContentInstance = null;
      });
    });
  }
})();
